import Image from "next/image";
import { cn } from "@/lib/utils";

interface IPhoneFrameProps {
  src: string;
  alt: string;
  /** Frame width in pixels (content scales to fit). */
  width?: number;
  /** Renders the pill notch overlay at the top of the screen. */
  showNotch?: boolean;
  /** Optional caption under the device. */
  caption?: string;
  captionClassName?: string;
  className?: string;
}

/**
 * Dark phone mockup wrapper for app screenshots, matching the redesign's
 * rounded device frames.
 */
export function PhoneFrame({
  src,
  alt,
  width = 262,
  showNotch = false,
  caption,
  captionClassName,
  className,
}: IPhoneFrameProps): React.ReactElement {
  return (
    <div className={className} style={{ width }}>
      <div className="rounded-[38px] bg-mauve-shadow-950 p-[11px] shadow-xl">
        <div className="relative overflow-hidden rounded-[29px] bg-black">
          {showNotch && (
            <div className="absolute left-1/2 top-[9px] z-[2] h-5 w-[92px] -translate-x-1/2 rounded-xl bg-black" />
          )}
          <Image
            src={src}
            alt={alt}
            width={width * 2}
            height={width * 4}
            className="block h-auto w-full"
            sizes={`${width}px`}
          />
        </div>
      </div>
      {caption && (
        <p
          className={cn(
            "mx-1 mb-1.5 mt-4 text-center font-sans text-[13.5px] font-semibold text-muted-foreground",
            captionClassName
          )}
        >
          {caption}
        </p>
      )}
    </div>
  );
}
